import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {OidcSecurityService} from "angular-auth-oidc-client";

export const IGNORE_401_ERROR = new HttpContextToken<boolean>(() => false);

let isHandling401 = false;

export function http401Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const router = inject(Router);
  const oidcSecurityService = inject(OidcSecurityService);

  if (req.context.get(IGNORE_401_ERROR)) {
    return next(req);
  }
  return next(req).pipe(tap({
    error: err => handleError(err, oidcSecurityService, router),
  }));
}

function handleError(err: HttpErrorResponse, oidcSecurityService: OidcSecurityService, router: Router) {
  if (err.status === 401) {
    if (isHandling401) {
      return;
    }
    isHandling401 = true;
    try {
      oidcSecurityService.logoffLocalMultiple();
    } catch {
      // Ignore if session state is already cleared
    }
    router.navigate(['/error/401']).finally(() => {
      setTimeout(() => {
        isHandling401 = false;
      }, 1000);
    });
  }
}
